import {IPaginatedResult} from './search';
import {IConnectionRequest} from './connection';

export interface INotificationBase {
    _id: string;
    type: NotificationType;
    message: string;
    status: NotificationStatus;
    lastModified: string;
    created: string;
}

export enum NotificationType {
    CONNECTION = 'CONNECTION',
    SEND_PRESENTATION = 'SEND_PRESENTATION',
    SHARE_PRESENTATION = 'SHARE_PRESENTATION',
    INVALID_PASSWORD = 'INVALID_PASSWORD',
    PRES_PASS_EXPIRED = 'PRESENTATION_PASSWORD_EXPIRED',
}

export enum NotificationStatus {
    ACTIVE = 'ACTIVE',
    SEEN = 'SEEN',
    READ = 'READ',
    RESOLVED = 'RESOLVED',
    DELETED = 'DELETED',
}

export type INotification =
    | ISendPresentationsNotification
    | ISharePresentationsNotification
    | IConnectionRequestNotifications
    | IInvalidPasswordNotification
    | IPresPasswordExpiredNotification;

export interface INotificationResponse extends IPaginatedResult<INotification> {
    numberOfUnseen: number;
}

export interface IConnectionRequestNotifications extends INotificationBase {
    type: NotificationType.CONNECTION;
    connectionRequest: IConnectionRequest;
}

export interface ISendPresentationsNotification extends INotificationBase {
    type: NotificationType.SEND_PRESENTATION;
    senderEmail: string;
    presentationIds: string[];
}

export interface ISharePresentationsNotification extends INotificationBase {
    type: NotificationType.SHARE_PRESENTATION;
    senderEmail: string;
    presentationIds: string[];
    isReadOnly: boolean;
}

export interface IPresPasswordExpiredNotification extends INotificationBase {
    type: NotificationType.PRES_PASS_EXPIRED;
    presentationId: string;
    userId: string;
}

export interface IInvalidPasswordNotification extends INotificationBase {
    type: NotificationType.INVALID_PASSWORD;
    numberOfDaysLeft: number;
}
